import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDownloadClientQuestionnaireLazyQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { Base64FileData } from 'api/types/data';

export const useDownloadClientQuestionnaire = () => {
  const [handler, { data, loading, error: apolloError }] =
    useDownloadClientQuestionnaireLazyQuery();

  const error = useError(apolloError);

  return {
    downloadClientQuestionnaire: useCallback(
      async (clientId: string) => {
        const res = await handler({
          variables: {
            id: clientId,
          },
        });
        return res.data?.clientQuestionnaire as Base64FileData | undefined;
      },
      [handler]
    ),
    data: data?.clientQuestionnaire as Base64FileData | undefined,
    loading,
    error,
  };
};
